/* Copyright (c) 2023-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { HigNavItem } from '../../types/hig-shared.types';

// Component-specific type aliases (enforce requirements via intersection types)
export type HigSidebarItem<T> = HigNavItem<T> & Required<Pick<HigNavItem<T>, 'svgIconId'>>;

export interface HigAccountInfoSidebarItem<T> extends HigSidebarItem<T> {
    /** User login status (for account items) */
    loggedIn?: boolean;
    /** User badge/avatar URL (for account items) */
    badgeUrl?: string;
    /** Subtitle text (for account items) */
    subtext?: string;
}

export enum HigSidebarAnimationState {
    Init = 'Init',
    Expanded = 'Expanded',
    Expanding = 'Expanding',
    Collapsed = 'Collapsed',
    Collapsing = 'Collapsing'
}

export interface HigSidebarOfflineIcon {
    visible: boolean;
    icon: string;
    tooltip: string;
}
